import React, { useState, useContext } from 'react';

import { Stepper, Step, StepLabel, Paper, Typography, MobileStepper, Hidden } from '@material-ui/core';

import ActionsContainer from './ActionsContainer';
import ChooseOptions from './ChooseOptions';
import ConfirmProviderTypes from './ConfirmProviderTypes';
import NextSteps from './NextSteps';
import {post} from "../../utils/OctoberApiUtils";
import {ProviderRequestsContext} from "../../context/ProviderRequestsContext";

import { useStyles, ColorlibConnector } from './ProviderRequestsFormStyles.js';

export default function ProviderRequestsForm() {
    const [activeStep, setActiveStep] = useState(0);
    const providerRequestsContext = useContext(ProviderRequestsContext);
    const [consentTerms, setConsentTerms] = useState(false);

    // Go to next step
    const handleNext = () => {
        setActiveStep(activeStep + 1);
    }

    // Go to previous step
    const handlePrev = () => {
        setActiveStep(activeStep - 1);
    }

    const handleConsentTerms = () => {
        setConsentTerms(!consentTerms);
    };

    const saveProviderRequests = async () => {
        try {
            await post('/api/react/add-event/provider-request', {selectedProviders:providerRequestsContext.state.selectedProviders, inviteId:providerRequestsContext.state.inviteId} );
        } catch (error) {
            console.error(`Cannot create provider request, error`, error);
        }
    };

    const handleSubmit = () => {
        saveProviderRequests();
        handleNext();
    }

    const getStepContent = (step) => {
        switch(step) {
            case 0:
                return (
                    <ChooseOptions
                        classes={classes}
                    />
                )
            case 1:
                return (
                    <ConfirmProviderTypes
                        classes={classes}
                        consentTerms={consentTerms}
                        handleConsentTerms={handleConsentTerms}
                    />
                )
            case 2:
                return (
                    <NextSteps
                        classes={classes}
                    />
                )
            default:
                break
        }
    }
    const classes = useStyles();
    const stepsLabel = [
        'Alege opțiuni',
        'Confirmare',
        'Next'
    ];
    
    return (
        <div className={`${classes.root} providerRequest`}>
            <div className={classes.formRoot}>
                <div className={classes.form}>
                    <Paper square elevation={0}>
                        <Typography className={classes.title}>
                            {activeStep === stepsLabel.length - 1 ? 'Următorii pași' : 'Obține furnizori'}
                        </Typography>
                    </Paper>
                    <Hidden xsDown>
                        <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}
                            connector={<ColorlibConnector />}
                        >
                            {stepsLabel.map((label) => (
                                <Step key={label}>
                                    <StepLabel 
                                        classes={{
                                            alternativeLabel: classes.alternativeLabel
                                        }}
                                        StepIconProps={{
                                            classes: { 
                                                root: classes.stepIcon,
                                                completed: classes.completedIcon,
                                                active: classes.activeIcon
                                            }
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Hidden>
                    <Hidden mdUp>
                        <div className={classes.mobileContainer}>
                            <Hidden smUp>
                                <div className={classes.mobileStepLabel}>
                                    <MobileStepper
                                        steps={stepsLabel.length}
                                        position="static"
                                        variant="text"
                                        activeStep={activeStep}
                                    />
                                    <Typography>{stepsLabel[activeStep]}</Typography>
                                </div>
                            </Hidden>
                        </div>
                    </Hidden>
                    {getStepContent(activeStep)}
                    {activeStep !== stepsLabel.length -1 ?
                        <ActionsContainer
                            activeStep={activeStep}
                            handleNext={handleNext}
                            handlePrev={handlePrev}
                            handleSubmit={handleSubmit}
                            classes={classes}
                            consentTerms={consentTerms}
                        /> : ''
                    }
                </div>
            </div>
        </div>
    )
}
